const types = {
    CHANGE_PASSWORD_POST: 'changePassword/post',
    CHANGE_PASSWORD_ERROR: 'changePassword/APIError',
}

export default types;